import { createFileRoute } from "@tanstack/react-router";
import type { RouterContextType } from "@/api/permissions/permissions.api";
import { TeamAssignmentsPage } from "@/components/features/TeamAssignments/TeamAssignmentsPage/TeamAssignmentsPage";
import { authGuardWithPermissions } from "@/utils/authGuard";

export const Route = createFileRoute("/_authenticated/clients/team-assignments/")({
  component: TeamAssignmentsPage,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});
